(function () {
  class KhelspaceCart extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.labels = JSON.parse(this.dataset.labels);
      this.root = this.dataset.root;
      this.busy = false;
      this.addEventListener('click', event => {
        if (event.target === this.dialog || event.target.closest('[data-cart-close]')) this.close();
        const control = event.target.closest('[data-line-action]');
        if (control && !control.disabled) this.changeLine(control);
      });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-line-input]')) this.changeLine(event.target);
      });
      this.dialog.addEventListener('close', () => this.afterClose());
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled])')].filter(el => el.getClientRects().length);
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      });
      this.onSubmit = event => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.matches('.kslp__form,[data-ksm-product-form],[data-kscart-add]')) return;
        if (event.submitter?.matches('[data-buy-now]') || event.submitter?.name === 'return_to') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy || event.submitter?.disabled || !form.checkValidity()) return;
        this.addProduct(form, event.submitter || form.querySelector('[type=submit]'));
      };
      document.addEventListener('submit', this.onSubmit, true);
      this.setExpanded(false);
    }
    disconnectedCallback() {
      document.removeEventListener('submit', this.onSubmit, true);
      if (this.dialog?.open) this.close();
      this.ready = false;
    }
    setExpanded(open) {
      document.querySelectorAll('[data-side-drawer="#Cart-Drawer"] button').forEach(button => {
        button.setAttribute('aria-controls', 'KsmCartDialog');
        button.setAttribute('aria-expanded', String(open));
      });
    }
    setActiveElement(element) { this.trigger = element; }
    open(trigger, options = {}) {
      if (this.dialog.open) return;
      if (trigger) this.trigger = trigger;
      this.hadBodyLock = document.body.classList.contains('overflow-hidden');
      this.hadHtmlLock = document.documentElement.hasAttribute('scroll-lock');
      this.dialog.showModal();
      document.body.classList.add('overflow-hidden');
      document.documentElement.setAttribute('scroll-lock', '');
      this.setExpanded(true);
      if (!options.skipRefresh && !this.busy) this.refreshOnOpen();
    }
    close() { if (this.dialog.open) this.dialog.close(); }
    afterClose() {
      if (!this.hadBodyLock) document.body.classList.remove('overflow-hidden');
      if (!this.hadHtmlLock) document.documentElement.removeAttribute('scroll-lock');
      this.setExpanded(false);
      requestAnimationFrame(() => { if (!this.dialog.open && this.trigger?.isConnected) this.trigger.focus({preventScroll:true}); });
    }
    notice(message, error = false) {
      const target = this.querySelector(error ? '[data-cart-error]' : '[data-cart-notice]');
      target.textContent = message;
      if (error && message) { const link=document.createElement('a');link.href=this.root+'cart';link.textContent=this.labels.view_cart;target.append(' ',link); }
      target.hidden = !message;
    }
    setBusy(busy) {
      this.busy = busy;
      this.querySelector('#KsmCartContent').setAttribute('aria-busy', String(busy));
      if (busy) {
        this.locked = [...this.querySelectorAll('[data-line-action],[data-line-input],[data-cart-checkout]')].map(el => ({el,disabled:el.disabled}));
        this.locked.forEach(({el}) => { el.disabled = true; });
      } else {
        this.locked?.forEach(({el,disabled}) => { if (el.isConnected) el.disabled = disabled; });
        this.locked = null;
      }
    }
    getSectionsToRender() { return [{id:'cart-drawer',selector:'#KsmCartContent'},{id:'cart-icon-bubble'}]; }
    async request(path, options = {}) {
      const response = await fetch(this.root + path, {credentials:'same-origin', ...options});
      const result = await response.json();
      if (!response.ok || result.status >= 400) {
        const error = new Error(result.description || result.message || this.labels.error);
        error.confirmed = true;
        throw error;
      }
      return result;
    }
    async fetchContents() {
      const sections = await this.request('?sections=cart-drawer,cart-icon-bubble');
      if (!this.applySections(sections)) throw new Error(this.labels.refresh_error);
    }
    applySections(sections) {
      const html = sections?.['cart-drawer'] || Object.entries(sections || {}).find(([key]) => key.includes('cart-drawer'))?.[1];
      if (!html) return false;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.querySelector('#KsmCartContent');
      const current = this.querySelector('#KsmCartContent');
      if (!fresh || !current) return false;
      const scroll = current.querySelector('[data-cart-scroll]').scrollTop;
      const active = document.activeElement;
      const key = this.lineFocus?.key || active.closest('[data-line-key]')?.dataset.lineKey;
      const action = this.lineFocus?.action || active.dataset.lineAction;
      const wasInput = this.lineFocus?.input || active.matches('[data-line-input]');
      current.replaceChildren(...fresh.childNodes);
      current.dataset.count = fresh.dataset.count;
      current.querySelector('[data-cart-scroll]').scrollTop = scroll;
      this.updateCounts(Number(fresh.dataset.count), sections?.['cart-icon-bubble']);
      if (key && this.dialog.open) {
        const line = [...current.querySelectorAll('[data-line-key]')].find(el => el.dataset.lineKey === key);
        const next = wasInput ? line?.querySelector('[data-line-input]') : line?.querySelector(`[data-line-action="${action}"]`);
        const target = next && !next.disabled ? next : line?.querySelector('[data-line-input]') || this.querySelector('[data-cart-close]');
        requestAnimationFrame(() => { if (this.dialog.open && target.isConnected) target.focus({preventScroll:true}); });
      }
      return true;
    }
    updateCounts(count, html) {
      if (html) {
        const doc = new DOMParser().parseFromString(html,'text/html');
        const markup = doc.querySelector('.shopify-section')?.innerHTML;
        if (markup) document.querySelectorAll('#cart-icon-bubble').forEach(el => { if (!el.closest('button,a')?.querySelector('.cart-text')) el.innerHTML = markup; });
      }
      this.querySelector('[data-kscart-count]').textContent = count;
      const label = this.labels.items.replace('[count]', count);
      document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = el.closest('.cart-text') ? `(${count})` : count; });
      document.querySelectorAll('[data-cart-text]').forEach(el => { el.textContent = label; });
      document.querySelectorAll('[data-side-drawer="#Cart-Drawer"] button,.cart-icon--drawer').forEach(el => el.setAttribute('aria-label',label));
    }
    async renderContents(response) {
      if (!this.applySections(response.sections)) await this.fetchContents();
      this.notice(this.labels.added);
      this.open(null,{skipRefresh:true});
    }
    async refreshOnOpen() {
      this.notice(''); this.notice('',true); this.setBusy(true);
      try { await this.fetchContents(); }
      catch (_) { this.notice(this.labels.refresh_error,true); }
      finally { this.setBusy(false); }
    }
    async addProduct(form, trigger) {
      const body = new FormData(form);
      const quantity = Number(body.get('quantity') || 1);
      const landing = form.matches('.kslp__form') ? form.closest('[data-kslp]') : null;
      if (!body.get('id') || !Number.isSafeInteger(quantity) || quantity < 1 || landing?.classList.contains('is-unavailable')) return;
      body.delete('return_to');
      body.set('sections','cart-drawer,cart-icon-bubble');
      body.set('sections_url',this.root);
      const targets = landing ? [...landing.querySelectorAll('button,input,select')] : [...form.querySelectorAll('button,input,select')];
      const states = targets.map(el => ({el,disabled:el.disabled}));
      const buttons = landing ? [...landing.querySelectorAll('[data-add],[data-sticky-add]')] : [trigger].filter(Boolean);
      const texts = buttons.map(el => ({el,text:el.innerHTML}));
      const oldError = form.querySelector('.kscart-form-status');
      oldError?.remove();
      states.forEach(({el}) => { el.disabled = true; });
      texts.forEach(({el}) => { el.textContent = this.labels.adding; });
      form.setAttribute('aria-busy','true'); form.classList.add('kscart-pending');
      this.setBusy(true); this.setActiveElement(trigger); this.notice('',true);
      let added = false;
      try {
        const response = await this.request('cart/add.js',{method:'POST',body});
        added = true;
        await this.renderContents(response);
        this.querySelector('[data-cart-scroll]').scrollTop = 0;
      } catch (error) {
        const message = added ? this.labels.refresh_error : error.confirmed ? error.message : this.labels.uncertain;
        if (added) { this.open(trigger,{skipRefresh:true}); this.notice(this.labels.added); this.notice(message,true); }
        else {
          const status = document.createElement('p'); status.className='kscart-form-status';status.setAttribute('role','alert');status.textContent=message+' ';
          const link=document.createElement('a');link.href=this.root+'cart';link.textContent=this.querySelector('.kscart__footer-links a')?.textContent || this.labels.view_cart;status.append(link);form.append(status);
          status.scrollIntoView({block:'nearest'});
        }
      } finally {
        states.forEach(({el,disabled}) => { el.disabled=disabled; });
        texts.forEach(({el,text}) => { el.innerHTML=text; });
        form.removeAttribute('aria-busy');form.classList.remove('kscart-pending');this.setBusy(false);
      }
    }
    async changeLine(control) {
      if (this.busy) return;
      const line = control.closest('[data-line-key]');
      const input = line.querySelector('[data-line-input]');
      const units = Number(line.dataset.units);
      const current = Number(line.dataset.quantity) / units;
      const action = control.dataset.lineAction;
      const step = Number(input.step) || 1;
      const min = Number(input.min) || 1;
      let quantity = action === 'remove' ? 0 : action === 'minus' ? current-step : action === 'plus' ? current+step : Number(input.value);
      const max = input.hasAttribute('max') ? Number(input.max) : Infinity;
      if (action !== 'remove' && (!Number.isSafeInteger(quantity) || quantity < min || quantity > max || (quantity-min)%step !== 0)) {
        input.value=current;this.notice(this.labels.invalid,true);return;
      }
      if (quantity === current) return;
      this.lineFocus = {key:line.dataset.lineKey,action,input:control.matches('[data-line-input]')};
      this.notice('',true);this.notice(this.labels.updating);this.setBusy(true);
      try {
        const response = await this.request('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.dataset.lineKey,quantity:quantity*units,sections:'cart-drawer,cart-icon-bubble',sections_url:this.root})});
        if (!this.applySections(response.sections)) await this.fetchContents();
        this.notice(this.labels.updated);
      } catch (error) {
        try { await this.fetchContents(); } catch (_) {}
        this.notice('');this.notice(error.confirmed ? error.message : this.labels.refresh_error,true);
      } finally { this.setBusy(false); this.lineFocus=null; }
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer',KhelspaceCart);
})();
